<template>
  <div class="sc-message--carousel-container">
    <div class="sc-message--carousel"
         ref="carousel"
         @scroll="handleScroll"
    >
      <div v-for="(card, i) in data"
           :key="i"
           class="sc-message--carousel-card"
      >
        <div class="sc-message--carousel-card-detail">
          <img :src="card.image_url"/>
          <p v-if="card.title" class="sc-message--carousel-card-title">{{card.title}}</p>
          <p v-if="card.text" class="sc-message--carousel-card-content">{{card.text}}</p>
        </div>

        <div v-if="card.buttons" class="sc-message--carousel-card-buttons">
          <template v-for="(button, idx) in card.buttons">
            <button v-if="['postback', 'callback'].includes(button.type)"
                    class="button"
                    :key="`button-${idx}`"
                    :style="messageColors"
                    @click="$emit('buttonPressed', button)"
            >
              <span class="button-title">{{button.title}}</span>
            </button>
            <a v-if="button.type === 'url'" :href="button.payload" target="_blank" :key="`button-${idx}`" class="button" :style="messageColors" @click="$emit('buttonPressed', button)"><span class="button-text">{{button.title}}</span></a>
            <a v-if="button.type === 'phone'" :href="`tel:${button.payload}`" target="_parent" :key="`button-${idx}`" class="button" :style="messageColors" @click="$emit('buttonPressed', button)"><span class="button-text">{{button.title}}</span></a>
          </template>
        </div>
      </div>
    </div>

    <div v-if="showLeftArrow"
         class="sc-message--carousel-arrow-container arrow-left"
         @click="scrollLeft"
    >
      <button class="sc-message--carousel-arrow">
        <icon-arrow-down fill="black"/>
      </button>
    </div>

    <div v-if="showRightArrow"
         class="sc-message--carousel-arrow-container arrow-right"
         @click="scrollRight"
    >
      <button class="sc-message--carousel-arrow">
        <icon-arrow-down fill="black"/>
      </button>
    </div>

  </div>
</template>

<script>
import IconArrowDown from './../icons/icons/IconArrowDown'

export default {
  components: { IconArrowDown },
  props: {
    data: {
      type: Array,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showLeftArrow: false,
      showRightArrow: false
    }
  },
  methods: {
    handleScroll () {
      const carousel = this.$refs.carousel
      this.showLeftArrow = carousel.scrollLeft > 0
      this.showRightArrow = carousel.scrollLeft < (carousel.scrollWidth - carousel.clientWidth)
    },
    scrollLeft () {
      const carousel = this.$refs.carousel
      carousel.scrollBy({ left: -160, behavior: 'smooth' })
    },
    scrollRight () {
      const carousel = this.$refs.carousel
      carousel.scrollBy({ left: 160, behavior: 'smooth' })
    }
  },
  mounted () {
    this.handleScroll() // Initial check to set arrow visibility
  }
}
</script>
